import { render } from "./AdminDashboardNav.vue?vue&type=template&id=59165500&scoped=true"
import script from "./AdminDashboardNav.vue?vue&type=script&lang=js"
export * from "./AdminDashboardNav.vue?vue&type=script&lang=js"

import "./AdminDashboardNav.vue?vue&type=style&index=0&id=59165500&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59165500"]])

export default __exports__